import React from "react";
import { CircularProgress } from "@mui/material";

import StyledCircularProgress from "./styles";

const LoadingComponent = () => {
  return (
    <StyledCircularProgress>
      <CircularProgress />
    </StyledCircularProgress>
  );
};

export default LoadingComponent;
